import { type MarketBoxes } from '@/common/types/shop/marketBoxes';
import { type TypeGradient } from '@/components/ui/Gradient/RadialCircleGradient';

import cash from '/img/icons/cash.png';
import ingot from '/img/shop/boxes/ingot.svg';
import mattock from '/img/shop/boxes/mattock.svg';

type ticketVar =
  | 'gold'
  | 'ticker-center'
  | 'purple'
  | 'blue'
  | 'gold-small'
  | 'red'
  | 'red-small';

type ticketExtrsVar = 'gold' | 'blue';
export const infoBox: Record<
  MarketBoxes,
  {
    title: string;
    text?: string;
    gradient: TypeGradient;
    add?: string[];
    ticketVariant?: { text: string; var: ticketVar; extra?: ticketExtrsVar };
  }
> = {
  free: {
    title: 'Free Pack',
    text: 'Claim daily for free',
    gradient: 'green',
  },
  ads: {
    title: 'ADS Pack',
    text: 'Watch ads and get bonuses',
    gradient: 'gray',
  },
  starter: {
    title: 'Standard pack',
    text: undefined,
    gradient: 'azure',
    add: [cash, mattock, ingot],
    ticketVariant: {
      text: 'random',
      var: 'gold',
    },
  },
  pro: {
    title: 'Pro Pack',
    text: undefined,
    gradient: 'blue',
    ticketVariant: {
      text: '230% VALUE',
      var: 'ticker-center',
      extra: 'blue',
    },
  },
  gold: {
    title: 'Gold Pack',
    text: undefined,
    gradient: 'yellow',
    ticketVariant: {
      text: '270% VALUE',
      var: 'ticker-center',
      extra: 'gold',
    },
  },
  elit: {
    title: 'Elite Pack',
    text: undefined,
    gradient: 'purple',
    ticketVariant: {
      text: '290% VALUE',
      var: 'purple',
    },
  },
};
